import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
 import axios from '../../redux/axios';

const initialState = {
  completeTepmalte: [],
  draftTepmalte: [],
  isFetching: false,
  isCompSuccess: false,
  isDraftSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getCompleteTemplate = createAsyncThunk(
  '/template?limit=10&page=1',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/template?limit=10&page=1',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let response = await axios({
        url: `/api/template?limit=10&page=${udata}`,
        method: 'get',
        //timeout: 8000,
        headers: {
            //'Content-Type': 'application/json',
            "Authorization" : `Bearer ${tokenStr}`
        }
    })
      
      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const getDraftTemplate = createAsyncThunk(
    '/template/draft?limit=10&page=1',
    async (udata, thunkAPI) => {
      try {
        const { auth } = thunkAPI.getState()
        let tokenStr = auth.user.token;
        //const response = await axios.get('/api/template/draft?limit=10&page=1',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });
  
        let response = await axios({
          url: `/api/template/draft?limit=10&page=${udata}`,
          method: 'get',
          //timeout: 8000,
          headers: {
              //'Content-Type': 'application/json',
              "Authorization" : `Bearer ${tokenStr}`
          }
      })
        
        let data = response.data;
        if (response.status === 200) {
          return data;
        }
        else if (data.code === 200) {
          return data;
        }
        else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (err) {
        if (!err.response) {
          throw err
        }
  
        return thunkAPI.rejectWithValue(err.response.data)
      }
    }
  );




export const viewtemplateSlice = createSlice({
  name: 'viewComDraftTemplate',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateTemplate: (state, {payload}) => { 
      //state.user = {};
      // state.isFetching = false;
      // state.isCompSuccess = false;
       state.isError = false;
       state.errorMessage = '';
    },
  },

  extraReducers: {
    [getCompleteTemplate.fulfilled]: (state, { payload }) => {
     
          state.completeTepmalte = payload.data;
          state.isFetching = false;
          state.isCompSuccess = true;
          return state;
        },
        [getCompleteTemplate.pending]: (state) => {
          state.isFetching = true;
        },
        [getCompleteTemplate.rejected]: (state, { payload }) => {
          state.isFetching = false;
          state.isError = true;
          if(payload){
            state.errorMessage = payload.message;
          }
          else{
            state.errorMessage = 'Internal error';
          }
        },
    

    [getDraftTemplate.fulfilled]: (state, { payload }) => {
     
        state.draftTepmalte = payload.data;
        state.isFetching = false;
        state.isDraftSuccess = true;
        return state;
      },
      [getDraftTemplate.pending]: (state) => {
        state.isFetching = true;
      },
      [getDraftTemplate.rejected]: (state, { payload }) => {
        state.isFetching = false;
        state.isError = true;
        if(payload){
          state.errorMessage = payload.message;
        }
        else{
          state.errorMessage = 'Internal error';
        }
      }

 },     

});


export const copyCompletedProcess = createAsyncThunk(
  '/template/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/template/',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let response = await axios({
        url: `/api/template/copy/${udata}`,
        method: 'post',
        //timeout: 8000,
        headers: {
            //'Content-Type': 'application/json',
            "Authorization" : `Bearer ${tokenStr}`
        }
    })
      
      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const SearchCompleteProcess = (sdata) => async (dispatch, getState) => {
  try {
  const { auth } = getState()
   let tokenStr = auth.user.token;
   let response = await axios({
    url: `/api/template/search?search=${sdata}`,
    method: 'get',
    headers: {
        //'Content-Type': 'application/json',
        "Authorization" : `Bearer ${tokenStr}`
    }
   });
    
   let data = response.data;
   if (response.status === 200) {
     return data;
   }
   else if (data.code === 200) {
     return data;
   }
   else {
    return [];
   }
 } catch (err) {
   if (!err.response) {
     throw err
   }
    
  }
};




export const SearchDraftProcess = (sdata) => async (dispatch, getState) => {
  try {
  const { auth } = getState()
   let tokenStr = auth.user.token;
   let response = await axios({
    url: `/api/template/draft/search?search=${sdata}`,
    method: 'get',
    headers: {
        //'Content-Type': 'application/json',
        "Authorization" : `Bearer ${tokenStr}`
    }
   });
    
   let data = response.data;
   if (response.status === 200) {
     return data;
   }
   else if (data.code === 200) {
     return data;
   }
   else {
    return [];
   }
 } catch (err) {
   if (!err.response) {
     throw err
   }
    
  }
};



export const delCompletedProcess = createAsyncThunk(
  '/template/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/template/',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let response = await axios({
        url: `/api/template/${udata}`,
        method: 'delete',
        //timeout: 8000,
        headers: {
            //'Content-Type': 'application/json',
            "Authorization" : `Bearer ${tokenStr}`
        }
    })
      
      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);




export const {clearStateTemplate} = viewtemplateSlice.actions;

export function clearState() {
  
  return async (dispatch) => {
    dispatch(clearStateTemplate());
  }
}

export const viewTemplateSelector = (state) => state.viewtemplate ;

export default viewtemplateSlice.reducer;
